/* When the product form is submitted with a required option unselected, the
   browser flags it with native validation. The required option controls (frame
   cards, config cards, dropdowns) are visually hidden, so the browser's own
   scroll can land in the wrong spot. This scrolls the page to the topmost
   offending option section so the customer can see exactly what's needed. */
(function () {
  var best = null;
  var scheduled = false;

  document.addEventListener(
    'invalid',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var container = t.closest(
        '.custom-option, .option-selector, .option-selector--frame, .product-info__block'
      );
      if (!container) return;

      if (!best || container.getBoundingClientRect().top < best.getBoundingClientRect().top) {
        best = container;
      }

      if (!scheduled) {
        scheduled = true;
        setTimeout(function () {
          scheduled = false;
          if (!best) return;
          var target = best;
          best = null;
          var top = target.getBoundingClientRect().top + window.pageYOffset - 120;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }, 0);
      }
    },
    true // capture — the invalid event does not bubble
  );
})();
